export default "__VITE_ASSET__DJaRWcdB__"